import { render, staticRenderFns } from "./JSONTextArea.vue?vue&type=template&id=66636d48&scoped=true&"
import script from "./JSONTextArea.vue?vue&type=script&lang=js&"
export * from "./JSONTextArea.vue?vue&type=script&lang=js&"
import style0 from "./JSONTextArea.vue?vue&type=style&index=0&id=66636d48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66636d48",
  null
  
)

export default component.exports